<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    bottom
    left
    max-width="300"
    min-width="200"
    offset-x
    offset-y
    origin="top right"
    transition="scale-transition"
  >
    <template v-slot:activator="{ attrs, on }">
      <v-card
        id="settings"
        class="py-1 px-1"
        color="#00000018"
        dark
        flat
        style="position: fixed; bottom: 10px; right: -66px;"
        width="100"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>
          mdi-cog
        </v-icon>
      </v-card>
    </template>

    <v-card
      v-if="1==0"
      class="py-2"
    >
      <v-card-text>
        <base-btn
          v-if="false"
          block
          href="https://store.vuetifyjs.com/product/zero-theme-free/?ref=vtyd-settings"
          class="mb-6"
          color="accent"
          target="_blank"
        >
          Free Download
        </base-btn>
        <!--
        {{mode}}
        @click="menu = false"
        -->
        This is a future place for 'Settings'<br>
        Currently it is inactive.
        <v-divider />
        <base-btn
          v-if="mode=='Home'"
          :to="{ name: 'Sink' }"
          block
          color="red darken-1"
          dark
          size="x-small"
          @click="changeMode('Sink')"
        >
          View All Components
        </base-btn>

        <base-btn
          v-if="mode=='Sink'"
          :to="{ name: 'Home' }"
          block
          color="green darken-1"
          dark
          size="x-large"
          @click="changeMode('Home')"
        >
          Hide All Components
        </base-btn>

        <v-divider class="my-6" />

        <base-img
          v-if="false"
          class="mx-auto mb-6"
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-light.png"
          width="88"
        />

        <div
          v-if="false"
          class="text-center"
        >
          <base-btn
            :tile="false"
            :to="{ name: 'Pro' }"
            rounded
            @click="menu = false"
          >
            Go Pro

            <v-icon right>
              mdi-rocket
            </v-icon>
          </base-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    name: 'HomeSettings',

    data () {
      return {
        colors: [
          this.$vuetify.theme.themes.light.primary,
          '#9368e9',
          '#F4511E',
        ],
        menu: false,
        mode: 'Home',
      }
    },
    methods: {
      changeMode: function (mm) {
        this.mode = mm // "Sink" or "Home"
        this.menu = false
      },
    },
  }
</script>
